"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgUnderfloorHeatingOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M10.5 22h14a3.5 3.5 0 000-7h-14a1.5 1.5 0 010-3h14a3.5 3.5 0 000-7H11v2h13.5a1.5 1.5 0 010 3h-14a3.5 3.5 0 000 7h14a1.5 1.5 0 010 3h-14a3.5 3.5 0 000 7H27v-2H10.5a1.5 1.5 0 010-3z" }),
        React.createElement("circle", { cx: 6, cy: 6, r: 2 })));
}
exports.default = SvgUnderfloorHeatingOutline;
//# sourceMappingURL=UnderfloorHeatingOutline.js.map